(function() {
  'use strict';

  // Simple Bundles' own placeholder option text — matched, never shown.
  var PLACEHOLDER_TEXT = 'Please select an option';

  // Shopper-facing wording from the theme's language file (snippets/js-strings.liquid).
  function str(key) {
    var s = window.notedStrings && window.notedStrings.bundle;
    return (s && s[key]) || '';
  }
  // Gender values arrive in English from the product data; show them translated.
  function genderLabel(value) {
    return { 'For Him': str('for_him'), 'For Her': str('for_her'), 'Unisex': str('unisex') }[value] || value;
  }
  var BUNDLE_CONTAINER_ID = 'simple-bundles-io-options';

  var addToCartButton = null;
  var isManualSubmit = false;
  var bundleReady = false;

  // Mobile overlay references (Phase M2)
  var overlayEl = null;
  var overlayBackdrop = null;
  var mobileTriggerEl = null;
  var overlayBundleSize = 0;
  // Slot-aware model ("size steps"): each Simple Bundles slot has a size (100ml / 5ml / …).
  // Selections are partitioned by size so each size group is filled independently.
  var overlaySlotSizes = [];  // per slot index, e.g. ["100ml","5ml","5ml","5ml","5ml","5ml"]
  var overlaySizeGroups = []; // ordered unique sizes: [{ size:"100ml", max:1 }, { size:"5ml", max:5 }]
  var activeSize = '';        // which size group the customer is currently filling
  var overlaySelections = {}; // { <size>: { <productName>: { qty, value, optionText } } }
  var savedBodyScrollY = 0; // Phase M6: iOS scroll lock
  // What the customer actually picked, per slot. Simple Bundles renders each select
  // with its first product already `selected`, so a native value alone is not a choice.
  var chosenValues = {};      // { <slot key>: <option value> }

  function slotKey(selectEl, index) {
    return selectEl.name || selectEl.id || String(index);
  }

  // ============================================
  // UTILITY
  // ============================================

  var _decodeEl = null;
  function decodeHTMLEntities(str) {
    if (!str || str.indexOf('&') === -1) return str;
    if (!_decodeEl) _decodeEl = document.createElement('textarea');
    _decodeEl.innerHTML = str;
    return _decodeEl.value;
  }

  function getBundleContainer() {
    return document.getElementById(BUNDLE_CONTAINER_ID);
  }

  function getBundleSelects() {
    var container = getBundleContainer();
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('select'));
  }

  // What a slot OFFERS — the identity used to decide whether two slots are one step.
  // Two slots merge only if a customer picking from either would see the same choices.
  // Deriving this from the options themselves (rather than a size parsed out of a label)
  // is what keeps a "100ml Diffuser" slot from colliding with the "100ml" perfume slot.
  function slotOptionsFingerprint(selectEl) {
    var vals = [];
    for (var i = 0; i < selectEl.options.length; i++) {
      if (isPlaceholder(selectEl.options[i])) continue;
      vals.push(selectEl.options[i].value);
    }
    return vals.sort().join('\u0001');
  }

  // What a slot is CALLED — display only, shown on the mobile step chip.
  // Preference: the option-text ml suffix ("Accra - 100ml" -> "100ml"), else the slot's
  // own dropdown title from the app ("Shower Gel", "Body Lotion", "For Him").
  function detectSlotLabel(selectEl) {
    var opts = selectEl.options;
    for (var i = 0; i < opts.length; i++) {
      if (isPlaceholder(opts[i])) continue;
      var m = decodeHTMLEntities(opts[i].text).trim().match(/(\d+\s?ml)\s*$/i);
      if (m) return m[1].replace(/\s+/g, '').toLowerCase();
      break; // first real option is representative of the slot
    }
    var lbl = selectEl.previousElementSibling;
    var labelText = (lbl && lbl.tagName === 'LABEL') ? lbl.textContent.trim() : '';
    return labelText || selectEl.id || selectEl.name || '';
  }

  // Build the slot -> group map and the ordered groups from the live selects.
  // Slots offering the same products collapse into one step (5 x 5ml stays a single
  // "5ml 0/5" step); slots offering different products each get their own.
  function buildSlotModel() {
    var selects = getBundleSelects();
    var prints = selects.map(slotOptionsFingerprint);

    overlaySizeGroups = [];
    overlaySlotSizes = [];

    prints.forEach(function(print, slotIndex) {
      var g = null;
      for (var i = 0; i < overlaySizeGroups.length; i++) {
        if (overlaySizeGroups[i].print === print) { g = overlaySizeGroups[i]; break; }
      }
      if (g) {
        g.max++;
      } else {
        // `size` is an opaque group key (not a size) so two steps that happen to share a
        // display label can never share a selection bucket. slotIndex is the group's
        // representative slot — the one the overlay reads its product list from.
        g = {
          size: 'g' + overlaySizeGroups.length,
          label: detectSlotLabel(selects[slotIndex]),
          print: print,
          max: 1,
          slotIndex: slotIndex
        };
        overlaySizeGroups.push(g);
      }
      overlaySlotSizes.push(g.size);
    });

    // If two steps would show the same chip label ("100ml" twice), fall back to each
    // slot's own dropdown title ("For Him" / "For Her") so they can be told apart.
    var labelCounts = {};
    overlaySizeGroups.forEach(function(g) {
      labelCounts[g.label] = (labelCounts[g.label] || 0) + 1;
    });
    overlaySizeGroups.forEach(function(g) {
      if (labelCounts[g.label] < 2) return;
      var lbl = selects[g.slotIndex].previousElementSibling;
      var title = (lbl && lbl.tagName === 'LABEL') ? lbl.textContent.trim() : '';
      if (title) g.label = title;
    });

    // Preserve any existing picks for groups that still exist; reset the rest.
    var fresh = {};
    overlaySizeGroups.forEach(function(g) { fresh[g.size] = overlaySelections[g.size] || {}; });
    overlaySelections = fresh;

    if (!activeSize || !overlaySelections.hasOwnProperty(activeSize)) {
      activeSize = overlaySizeGroups.length ? overlaySizeGroups[0].size : '';
    }
  }

  function getSizeLabel(size) {
    for (var i = 0; i < overlaySizeGroups.length; i++) {
      if (overlaySizeGroups[i].size === size) return overlaySizeGroups[i].label;
    }
    return size;
  }

  function isMultiSize() { return overlaySizeGroups.length > 1; }

  function getSizeMax(size) {
    for (var i = 0; i < overlaySizeGroups.length; i++) {
      if (overlaySizeGroups[i].size === size) return overlaySizeGroups[i].max;
    }
    return 0;
  }

  function getSizeQty(size) {
    var bucket = overlaySelections[size] || {};
    var total = 0;
    Object.keys(bucket).forEach(function(n) { total += bucket[n].qty; });
    return total;
  }

  function isSizeFull(size) { return getSizeQty(size) >= getSizeMax(size); }

  // A trailing "- 5ml" / "- 100ml" is a VARIANT SIZE, so the product is the part before it.
  // Any other trailing segment ("- Shower Gel") belongs to the product's own title.
  var SIZE_SUFFIX = /^\d+\s?ml$/i;

  // Parse option text — handles three formats from Simple Bundles:
  //   Format A (5ml bundles):   "ProductName - VariantSize" e.g. "Amsterdam - 5ml"
  //   Format B (100ml bundles): "VendorText"                e.g. "Alien Inspired"
  //   Format C (mixed bundles): a full product title that itself contains " - ",
  //                             e.g. "New York - Shower Gel" (its own product)
  // Order matters: C is checked first, then A's split, then B's substring scan.
  //
  // Returns `scentKey` alongside `name`: the base product to read SCENT metadata from
  // (inspired-by, gender) when the option's own product isn't in the lookups. The image
  // is deliberately NOT resolved through it — borrowing a bottle shot from a different
  // product is what made shower gels render as perfumes.
  function parseOption(optionText) {
    var text = decodeHTMLEntities(optionText.trim());
    var parts = text.split(' - ');
    var name = '';
    var scentKey = '';
    var inspiredBy = '';
    var image = '';

    var vendorLookup = window.bundleVendorLookup || {};
    var imageLookup = window.bundleImageLookup || {};
    var base = parts.length >= 2 ? parts[0].trim() : '';
    var suffix = parts.length >= 2 ? parts[parts.length - 1].trim() : '';

    if (vendorLookup[text] || imageLookup[text]) {
      // Format C: the option text IS a whole product title that happens to contain " - ",
      // e.g. "New York - Shower Gel" (a distinct product, not a variant of "New York").
      // This MUST be tested before the split below, or the split wins and the option
      // collapses onto the "New York" perfume — inheriting its image and its "inspired by".
      name = text;
      // Prefer the product's own scent data, but keep the base product as a fallback:
      // some of these titles carry no gender metafield of their own.
      scentKey = (base && vendorLookup[base]) ? base : text;
    } else if (base && SIZE_SUFFIX.test(suffix) && vendorLookup[base]) {
      // Format A: "ProductName - VariantSize" — the suffix is a size, so the product
      // really is `base` and all of its data applies.
      name = base;
      scentKey = base;
    } else if (base && vendorLookup[base]) {
      // A distinct product we cannot resolve — its title is in the bundle but the product
      // itself is absent from the lookups (it isn't published to the Online Store, so
      // Liquid never saw it). Keep its own full title and take only the SCENT text from
      // the base product; it gets no image and falls back to the placeholder rather than
      // showing the wrong bottle.
      name = text;
      scentKey = base;
    } else {
      // Format B: full string is the option text (e.g. "Alien Inspired")
      // Try to find a matching product by checking if any lookup key appears in the text
      var keys = Object.keys(vendorLookup);
      for (var i = 0; i < keys.length; i++) {
        if (text.toLowerCase().indexOf(keys[i].toLowerCase()) !== -1) {
          name = keys[i];
          break;
        }
      }
      // Fallback: use the full text as-is
      if (!name) name = text;
      scentKey = name;
    }

    // Look up inspired-by from vendor lookup, strip "Inspired By" prefix
    var rawVendor = decodeHTMLEntities(vendorLookup[name] || vendorLookup[scentKey] || '');
    inspiredBy = rawVendor.replace(/^Inspired By\s*/i, '').trim();

    // Images are resolved by the option's OWN product only — never through scentKey.
    image = imageLookup[name] || '';

    return { name: name, inspiredBy: inspiredBy, image: image, scentKey: scentKey };
  }

  function isPlaceholder(option) {
    return option.disabled || option.value === '' ||
           option.text.trim().toLowerCase() === PLACEHOLDER_TEXT.toLowerCase();
  }

  // ============================================
  // OUT-OF-STOCK OPTIONS
  // ============================================
  // window.bundleUnavailableLookup carries ONLY what Liquid found to be out of
  // stock, keyed two ways:
  //   "Lisbon - Shower Gel"  a whole product with nothing in stock
  //   "Turin - 100ml"        one size of a product whose other sizes are fine
  // Anything absent is treated as in stock, so a product Liquid never saw (not
  // published to the Online Store, or past the 50-per-loop limit) stays
  // selectable. Hiding a sellable product is the worse error of the two.
  function isOptionOutOfStock(optionEl) {
    var lookup = window.bundleUnavailableLookup;
    if (!lookup) return false;
    if (lookup[decodeHTMLEntities(optionEl.text).trim()]) return true;
    return !!lookup[parseOption(optionEl.text).name];
  }

  // Mark out-of-stock options disabled BEFORE anything reads the selects.
  // isPlaceholder() already treats a disabled option as "not a real choice", so
  // this one flag removes it from the desktop dropdown, the mobile overlay, the
  // slot model, the step counts and findOptionByName together. The native select
  // is hidden and a disabled option cannot be submitted, so the app never
  // receives one either.
  //
  // Fails open per slot: if EVERY choice in a slot is out of stock the slot is
  // left alone, because an empty picker with no explanation is a worse failure
  // than showing one unbuyable option.
  function markOutOfStockOptions(selects) {
    selects.forEach(function(select) {
      var real = [];
      var gone = [];
      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (isPlaceholder(opt)) continue;
        real.push(opt);
        if (isOptionOutOfStock(opt)) gone.push(opt);
      }
      if (gone.length === 0 || gone.length === real.length) return;
      gone.forEach(function(opt) { opt.disabled = true; });
    });
  }

  function getProductForm() {
    // Noted 2.0 PDP form (Shopify {% form 'product' %} -> action="/cart/add", id="product-form-...")
    return document.querySelector('form[action$="/cart/add"]') ||
           document.querySelector('form[id^="product-form-"]');
  }

  function getAddToCartButton() {
    var form = getProductForm();
    if (!form) return null;
    return form.querySelector('[data-atc]') ||
           form.querySelector('button[type="submit"]') ||
           form.querySelector('.btn');
  }

  // ============================================
  // DROPDOWN BUILDING
  // ============================================

  function buildDropdown(nativeSelect, index) {
    // Hide native select
    nativeSelect.style.display = 'none';

    // Sort options alphabetically by product title
    var options = Array.prototype.slice.call(nativeSelect.options);
    var regularOptions = options.filter(function(opt) { return !isPlaceholder(opt); });
    regularOptions.sort(function(a, b) {
      var nameA = parseOption(a.text).name.toLowerCase();
      var nameB = parseOption(b.text).name.toLowerCase();
      return nameA.localeCompare(nameB);
    });

    // Wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'bundle-dropdown';
    wrapper.dataset.index = index;

    // Selected display (trigger)
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bundle-dropdown__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerImage = document.createElement('div');
    triggerImage.className = 'bundle-dropdown__trigger-image';
    triggerImage.innerHTML = '<div class="bundle-dropdown__placeholder-icon"></div>';

    var triggerText = document.createElement('div');
    triggerText.className = 'bundle-dropdown__trigger-text';
    triggerText.innerHTML = '<span class="bundle-dropdown__trigger-label">' + str('selection').replace('{number}', index + 1) + '</span>' +
                            '<span class="bundle-dropdown__trigger-value">' + str('placeholder') + '</span>';

    var triggerArrow = document.createElement('div');
    triggerArrow.className = 'bundle-dropdown__arrow';
    triggerArrow.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    trigger.appendChild(triggerImage);
    trigger.appendChild(triggerText);
    trigger.appendChild(triggerArrow);

    // Options panel
    var panel = document.createElement('div');
    panel.className = 'bundle-dropdown__panel';
    panel.setAttribute('role', 'listbox');

    // Search bar
    var searchWrap = document.createElement('div');
    searchWrap.className = 'bundle-dropdown__search';

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'bundle-dropdown__search-input';
    searchInput.placeholder = str('search');
    searchInput.setAttribute('autocomplete', 'off');

    var searchClear = document.createElement('button');
    searchClear.type = 'button';
    searchClear.className = 'bundle-dropdown__search-clear';
    searchClear.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    searchClear.style.display = 'none';

    searchWrap.appendChild(searchInput);
    searchWrap.appendChild(searchClear);
    panel.appendChild(searchWrap);

    // Column headers
    var header = document.createElement('div');
    header.className = 'bundle-dropdown__header';
    header.innerHTML = '<span class="bundle-dropdown__col-name">' + str('col_product') + '</span>' +
                       '<span class="bundle-dropdown__col-vendor">' + str('col_inspired') + '</span>';
    panel.appendChild(header);

    // Options list
    var list = document.createElement('div');
    list.className = 'bundle-dropdown__list';

    // No results message
    var noResults = document.createElement('div');
    noResults.className = 'bundle-dropdown__no-results';
    noResults.textContent = str('no_results');
    noResults.style.display = 'none';

    regularOptions.forEach(function(nativeOpt) {
      var data = parseOption(nativeOpt.text);

      var item = document.createElement('div');
      item.className = 'bundle-dropdown__option';
      item.setAttribute('role', 'option');
      item.dataset.value = nativeOpt.value;
      item.dataset.name = data.name;
      item.dataset.optionText = nativeOpt.text;
      item.dataset.inspiredBy = data.inspiredBy;

      item.innerHTML = '<span class="bundle-dropdown__col-name">' + data.name + '</span>' +
                       '<span class="bundle-dropdown__col-vendor">' + data.inspiredBy + '</span>';

      list.appendChild(item);
    });

    list.appendChild(noResults);
    panel.appendChild(list);
    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);

    // Insert after native select
    nativeSelect.parentNode.insertBefore(wrapper, nativeSelect.nextSibling);

    // ---- Search wiring ----

    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim().toLowerCase();
      searchClear.style.display = query ? '' : 'none';

      var visibleCount = 0;
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        var name = (el.dataset.name || '').toLowerCase();
        var inspiredBy = (el.dataset.inspiredBy || '').toLowerCase();
        var matches = !query || name.indexOf(query) !== -1 || inspiredBy.indexOf(query) !== -1;
        el.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      noResults.style.display = visibleCount === 0 ? '' : 'none';
    });

    searchClear.addEventListener('click', function(e) {
      e.stopPropagation();
      searchInput.value = '';
      searchClear.style.display = 'none';
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        el.style.display = '';
      });
      noResults.style.display = 'none';
      searchInput.focus();
    });

    // Prevent clicks inside search from closing dropdown
    searchWrap.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    // ---- Toggle open/close ----

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = wrapper.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        // Focus search and reset filter on open
        searchInput.value = '';
        searchClear.style.display = 'none';
        list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
          el.style.display = '';
        });
        noResults.style.display = 'none';
        setTimeout(function() { searchInput.focus(); }, 50);
      }
    });

    // Paint one option as this slot's selection. `announce` is false when we are
    // only restoring state onto a freshly rebuilt picker (see below) — firing
    // `change` there would bounce straight back through the app and rebuild again.
    function applySelection(optionEl, announce) {
      var value = optionEl.dataset.value;
      var name = optionEl.dataset.name;
      var inspiredBy = optionEl.dataset.inspiredBy;

      // Update native select
      nativeSelect.value = value;
      if (announce !== false) {
        chosenValues[slotKey(nativeSelect, index)] = value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update trigger display
      var img = parseOption(optionEl.dataset.optionText || name).image;
      if (img) {
        triggerImage.innerHTML = '<img src="' + img + '" alt="' + name + '" />';
      } else {
        triggerImage.innerHTML = '<div class="bundle-dropdown__placeholder-icon"></div>';
      }
      triggerText.innerHTML = '<span class="bundle-dropdown__trigger-label">' + name + '</span>' +
                              '<span class="bundle-dropdown__trigger-value">' + inspiredBy + '</span>';

      // Mark selected in list
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        el.classList.remove('is-selected');
      });
      optionEl.classList.add('is-selected');

      // Mark dropdown as having a user selection
      wrapper.classList.add('has-selection');
      wrapper.dataset.selectedTitle = name;

      // Close
      wrapper.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      // Update button states
      updateButtonState();
    }

    // ---- Option click → update native select + trigger display ----

    list.addEventListener('click', function(e) {
      var optionEl = e.target.closest('.bundle-dropdown__option');
      if (!optionEl) return;
      applySelection(optionEl, true);
    });

    // Restore the customer's own pick. Simple Bundles injects its own hidden field
    // once every slot is filled; that mutation trips our MutationObserver, which
    // rebuilds the pickers from scratch, and they used to come back blank even
    // though the customer had chosen. Only a recorded choice is restored: the app
    // also pre-selects the first product in every slot on load, and restoring that
    // filled each slot with the same scent instead of showing the empty state.
    var chosen = chosenValues[slotKey(nativeSelect, index)];
    // Matched by comparing dataset values rather than an attribute selector —
    // option values are product titles and carry spaces, apostrophes and dashes.
    var restore = chosen && Array.prototype.filter.call(
      list.querySelectorAll('.bundle-dropdown__option'),
      function (el) { return el.dataset.value === chosen; }
    )[0];
    if (restore) {
      applySelection(restore, false);
    } else if (nativeSelect.options.length && isPlaceholder(nativeSelect.options[0])) {
      // Nothing chosen yet: put the hidden select back on its placeholder so it
      // agrees with the empty picker.
      nativeSelect.selectedIndex = 0;
    }

    return wrapper;
  }

  // ============================================
  // OPEN/CLOSE MANAGEMENT
  // ============================================

  function closeAllDropdowns() {
    document.querySelectorAll('.bundle-dropdown.is-open').forEach(function(dd) {
      dd.classList.remove('is-open');
      dd.querySelector('.bundle-dropdown__trigger').setAttribute('aria-expanded', 'false');
    });
  }

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.bundle-dropdown')) {
      closeAllDropdowns();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      closeOverlay();
    }
  });

  // ============================================
  // BUTTON STATE MANAGEMENT (Phase 4)
  // ============================================

  // Check our custom UI, not the native selects (Simple Bundles pre-selects values underneath)
  function getUnselectedDropdowns() {
    var dropdowns = document.querySelectorAll('.bundle-dropdown');
    var missing = [];

    dropdowns.forEach(function(dd) {
      if (!dd.classList.contains('has-selection')) {
        var index = parseInt(dd.dataset.index, 10) + 1;
        missing.push(str('selection').replace('{number}', index));
      }
    });

    return missing;
  }

  function areAllOptionsSelected() {
    return getUnselectedDropdowns().length === 0;
  }

  function getUpsellAddButton() {
    return document.querySelector('.lb-spc-details-btn');
  }

  function updateButtonState() {
    if (!bundleReady) return;

    if (!addToCartButton || !addToCartButton.isConnected) {
      addToCartButton = getAddToCartButton();
    }

    var upsellButton = getUpsellAddButton();
    var allSelected = areAllOptionsSelected();

    // Button stays enabled — modal handles validation on click
    if (addToCartButton) {
      addToCartButton.disabled = false;
    }

    if (upsellButton) {
      if (!upsellButton.dataset.bundleClickHandler) {
        upsellButton.dataset.bundleClickHandler = 'true';
        upsellButton.addEventListener('click', function(e) {
          if (!areAllOptionsSelected()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }

      if (allSelected) {
        upsellButton.style.pointerEvents = '';
        upsellButton.style.opacity = '';
      } else {
        upsellButton.style.pointerEvents = 'none';
        upsellButton.style.opacity = '0.5';
      }
    }
  }

  // ============================================
  // DUPLICATE DETECTION (Phase 4)
  // ============================================

  function getAllSelectedProducts() {
    var dropdowns = document.querySelectorAll('.bundle-dropdown.has-selection');
    var selected = [];

    dropdowns.forEach(function(dd) {
      if (dd.dataset.selectedTitle) {
        selected.push(dd.dataset.selectedTitle);
      }
    });

    return selected;
  }

  function areAllSelectionsTheSame(selections) {
    if (selections.length <= 1) return false;
    var first = selections[0];
    return selections.every(function(s) { return s === first; });
  }

  // Single modal — two modes: missing selections or duplicate warning
  function createBundleModal(options) {
    var existing = document.getElementById('bundle-modal');
    if (existing) existing.remove();

    var heading = options.heading;
    var body = options.body;
    var showProceed = options.showProceed || false;

    var modalHTML =
      '<div id="bundle-modal" style="display:flex;position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999;align-items:center;justify-content:center;">' +
        '<div class="bundle-modal__bg" style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);"></div>' +
        '<div class="bundle-modal__box" style="position:relative;z-index:2;background:#fff;padding:24px;border-radius:8px;max-width:440px;width:90%;">' +
          '<h3 style="margin:0 0 12px;">' + heading + '</h3>' +
          body +
          '<div style="display:flex;gap:10px;margin-top:20px;">' +
            '<button type="button" class="button bundle-modal__cancel" style="flex:1;">' + (showProceed ? str('cancel') : str('ok')) + '</button>' +
            (showProceed ? '<button type="button" class="button bundle-modal__proceed" style="flex:1;">' + str('add_to_cart') + '</button>' : '') +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    var modal = document.getElementById('bundle-modal');

    return new Promise(function(resolve) {
      function close(confirmed) {
        modal.remove();
        document.removeEventListener('keydown', onKey);
        resolve(confirmed);
      }

      function onKey(e) {
        if (e.key === 'Escape') close(false);
      }

      modal.querySelector('.bundle-modal__bg').addEventListener('click', function() { close(false); });
      modal.querySelector('.bundle-modal__cancel').addEventListener('click', function() { close(false); });

      var proceedBtn = modal.querySelector('.bundle-modal__proceed');
      if (proceedBtn) {
        proceedBtn.addEventListener('click', function() { close(true); });
      }

      document.addEventListener('keydown', onKey);
    });
  }

  // ============================================
  // FORM SUBMISSION HANDLING (Phase 4)
  // ============================================

  // Complete the add once the customer has confirmed the duplicate warning.
  //
  // This used to set a one-shot `isManualSubmit` flag and re-click Add to Basket,
  // relying on the form firing a SECOND submit event that this handler would then
  // wave through. On the live PDP that second submit never arrived: the confirm
  // did nothing at all, and the flag was left set — so the next genuine Add to
  // Basket skipped validation instead. Call the theme's own AJAX add directly:
  // no re-entry, no flag, no dependence on listener ordering.
  function addConfirmed() {
    if (typeof window.notedProductAddToCart === 'function') {
      window.notedProductAddToCart();
      return;
    }
    // Fallback for any template where main-product.js isn't doing the adding.
    var form = getProductForm();
    if (!form) return;
    isManualSubmit = true;
    if (form.requestSubmit) form.requestSubmit(getAddToCartButton() || undefined);
    else form.submit();
  }

  function handleFormSubmit(event) {
    if (isManualSubmit) {
      isManualSubmit = false;
      return;
    }

    // Mobile overlay: use overlay qty total as source of truth
    if (overlayBundleSize > 0 && mobileTriggerEl && window.matchMedia('(max-width: 768px)').matches) {
      var overlayTotal = getOverlayTotalQty();
      if (overlayTotal < overlayBundleSize) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var remaining = overlayBundleSize - overlayTotal;
        createBundleModal({
          heading: str('selections_required'),
          body: '<p>' + str(remaining !== 1 ? 'select_more_other' : 'select_more_one').replace('{count}', remaining) + '</p>' +
                '<p>' + str('items_selected_html').replace('{count}', overlayTotal).replace('{total}', overlayBundleSize) + '</p>',
          showProceed: false
        });

        return false;
      }
    }

    // 1. Check for missing selections (our UI is the source of truth)
    var missing = getUnselectedDropdowns();
    if (missing.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      createBundleModal({
        heading: str('selections_required'),
        body: '<p>' + str('make_choice') + '</p><p><strong>' + missing.join(', ') + '</strong></p>',
        showProceed: false
      });

      return false;
    }

    // 2. Check for all-same duplicates
    var selectedProducts = getAllSelectedProducts();
    if (selectedProducts.length > 1 && areAllSelectionsTheSame(selectedProducts)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      createBundleModal({
        heading: str('same_product'),
        body: '<p>' + str('same_product_body_html').replace('{count}', selectedProducts.length).replace('{name}', selectedProducts[0]) + '</p>' +
              '<p>' + str('continue_question') + '</p>',
        showProceed: true
      }).then(function(confirmed) {
        if (confirmed) addConfirmed();
      });

      return false;
    }
  }

  // ============================================
  // MOBILE OVERLAY (Phase M2 + M6 polish)
  // ============================================

  // Phase M6: screen reader announcement helper
  function announceToSR(message) {
    if (!overlayEl) return;
    var sr = overlayEl.querySelector('.bundle-overlay__sr-status');
    if (sr) sr.textContent = message;
  }

  // Phase M6: focus trap inside overlay
  function handleOverlayKeydown(e) {
    if (!overlayEl || !overlayEl.classList.contains('is-open')) return;

    if (e.key === 'Tab') {
      var focusable = overlayEl.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  function buildMobileTrigger(bundleSize) {
    // Don't double-build
    if (document.querySelector('.bundle-mobile-trigger')) return;

    var container = getBundleContainer();
    if (!container) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bundle-mobile-trigger';

    btn.innerHTML =
      '<div class="bundle-mobile-trigger__text">' +
        '<span class="bundle-mobile-trigger__label">' + str('select_fragrances') + '</span>' +
        '<span class="bundle-mobile-trigger__count">' + str('count_selected').replace('{count}', 0).replace('{total}', bundleSize) + '</span>' +
      '</div>' +
      '<div class="bundle-mobile-trigger__arrow">' +
        '<svg width="14" height="14" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>';

    btn.addEventListener('click', function() {
      openOverlay();
    });

    // Insert at the top of the bundle container
    container.insertBefore(btn, container.firstChild);
    mobileTriggerEl = btn;
  }

  function buildOverlayShell(bundleSize) {
    // Don't double-build
    if (document.querySelector('.bundle-overlay')) return;

    overlayBundleSize = bundleSize;

    // Backdrop
    var backdrop = document.createElement('div');
    backdrop.className = 'bundle-overlay-backdrop';
    backdrop.addEventListener('click', function() {
      closeOverlay();
    });

    // Panel
    var panel = document.createElement('div');
    panel.className = 'bundle-overlay';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', str('select_fragrances'));

    // -- Header --
    var header = document.createElement('div');
    header.className = 'bundle-overlay__header';

    // Top bar: search + close
    var topBar = document.createElement('div');
    topBar.className = 'bundle-overlay__top-bar';

    var search = document.createElement('div');
    search.className = 'bundle-overlay__search';
    search.innerHTML =
      '<div class="bundle-overlay__search-icon">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5"/><path d="M11 11L14.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</div>' +
      '<input type="text" class="bundle-overlay__search-input" placeholder="' + str('search_fragrances') + '" autocomplete="off">';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'bundle-overlay__close';
    closeBtn.setAttribute('aria-label', str('close_overlay'));
    closeBtn.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', function() {
      closeOverlay();
    });

    topBar.appendChild(search);
    topBar.appendChild(closeBtn);
    header.appendChild(topBar);

    // Size steps (segmented) — only shown for multi-size bundles; populated by buildSizeBar()
    var sizeBar = document.createElement('div');
    sizeBar.className = 'bundle-overlay__sizes';
    sizeBar.setAttribute('role', 'tablist');
    sizeBar.setAttribute('aria-label', str('choose_size'));
    sizeBar.style.display = 'none';
    header.appendChild(sizeBar);

    // Category tabs
    var tabs = document.createElement('div');
    tabs.className = 'bundle-overlay__tabs';
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', str('filter_category'));

    var tabLabels = ['All', 'For Him', 'For Her', 'Unisex'];
    tabLabels.forEach(function(label, i) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'bundle-overlay__tab' + (i === 0 ? ' is-active' : '');
      // Label is shown translated; the filter value stays the English data value.
      tab.textContent = label === 'All' ? str('all') : genderLabel(label);
      tab.dataset.filter = label === 'All' ? 'all' : label;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tabs.appendChild(tab);
    });

    header.appendChild(tabs);
    panel.appendChild(header);

    // -- Content (scrollable, empty for M3) --
    var list = document.createElement('div');
    list.className = 'bundle-overlay__list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', str('fragrances'));
    panel.appendChild(list);

    // -- Footer --
    var footer = document.createElement('div');
    footer.className = 'bundle-overlay__footer';
    footer.innerHTML =
      '<div class="bundle-overlay__footer-status">' +
        '<span class="bundle-overlay__footer-text">' + str('items_selected_caps').replace('{count}', 0).replace('{total}', bundleSize) + '</span>' +
        '<button type="button" class="bundle-overlay__footer-clear">' + str('clear_all') + '</button>' +
      '</div>' +
      '<div class="bundle-overlay__footer-row">' +
        '<button type="button" class="bundle-overlay__footer-btn">' + str('add_to_cart_caps') + '</button>' +
        '<button type="button" class="bundle-overlay__footer-clear bundle-overlay__footer-clear--sm">' + str('clear') + '</button>' +
      '</div>';
    panel.appendChild(footer);

    // Screen reader live region for selection announcements
    var srStatus = document.createElement('div');
    srStatus.className = 'bundle-overlay__sr-status';
    srStatus.setAttribute('role', 'status');
    srStatus.setAttribute('aria-live', 'polite');
    srStatus.setAttribute('aria-atomic', 'true');
    panel.appendChild(srStatus);

    // Append to body
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    overlayBackdrop = backdrop;
    overlayEl = panel;

    // Focus trap (Phase M6)
    panel.addEventListener('keydown', handleOverlayKeydown);
  }

  function openOverlay() {
    if (!overlayEl || !overlayBackdrop) return;

    // iOS scroll lock: save position, pin body
    savedBodyScrollY = window.scrollY;
    document.body.classList.add('bundle-overlay-open');
    document.body.style.top = '-' + savedBodyScrollY + 'px';

    // Show elements then trigger animation on next frame
    overlayBackdrop.style.display = 'block';
    overlayEl.style.display = 'flex';

    // Force reflow so transition plays
    overlayEl.offsetHeight; // eslint-disable-line no-unused-expressions

    overlayBackdrop.classList.add('is-open');
    overlayEl.classList.add('is-open');

    // Reset list scroll to top on each open
    var list = overlayEl.querySelector('.bundle-overlay__list');
    if (list) list.scrollTop = 0;

    // Restore selection state on reopen (Phase M4)
    updateOverlayUI();

    // Accessibility: move focus into overlay
    var searchInput = overlayEl.querySelector('.bundle-overlay__search-input');
    if (searchInput) {
      setTimeout(function() { searchInput.focus(); }, 50);
    }

    // Announce to screen readers
    announceToSR(str('sr_items_selected').replace('{count}', getOverlayTotalQty()).replace('{total}', overlayBundleSize));
  }

  function closeOverlay() {
    if (!overlayEl || !overlayBackdrop) return;
    if (!overlayEl.classList.contains('is-open')) return;

    // Phase M5: sync overlay selections → hidden native selects + update button states
    syncSelectionsToSelects();
    updateButtonState();

    overlayBackdrop.classList.remove('is-open');
    overlayEl.classList.remove('is-open');

    // Hide after transition ends (with fallback timeout)
    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      overlayEl.style.display = '';
      overlayBackdrop.style.display = '';
      overlayEl.removeEventListener('transitionend', onEnd);
    }
    function onEnd(e) {
      if (e.propertyName === 'transform') cleanup();
    }
    overlayEl.addEventListener('transitionend', onEnd);
    setTimeout(cleanup, 400); // fallback

    // iOS scroll lock: restore position
    document.body.classList.remove('bundle-overlay-open');
    document.body.style.top = '';
    window.scrollTo(0, savedBodyScrollY);

    // Accessibility: return focus to trigger button
    if (mobileTriggerEl) mobileTriggerEl.focus();
  }

  function updateMobileTrigger(selectedCount, bundleSize) {
    if (!mobileTriggerEl) return;

    var countEl = mobileTriggerEl.querySelector('.bundle-mobile-trigger__count');
    var labelEl = mobileTriggerEl.querySelector('.bundle-mobile-trigger__label');

    if (countEl) {
      countEl.textContent = str('count_selected').replace('{count}', selectedCount).replace('{total}', bundleSize);
    }

    if (labelEl) {
      if (selectedCount > 0 && selectedCount >= bundleSize) {
        labelEl.textContent = str('edit_selections');
      } else {
        labelEl.textContent = str('select_fragrances');
      }
    }
  }

  // ============================================
  // MOBILE OVERLAY — size steps (segmented)
  // ============================================

  // Build one segment per size group. Hidden entirely for single-size bundles.
  function buildSizeBar() {
    if (!overlayEl) return;
    var bar = overlayEl.querySelector('.bundle-overlay__sizes');
    if (!bar) return;

    bar.innerHTML = '';
    if (!isMultiSize()) { bar.style.display = 'none'; return; }
    bar.style.display = '';

    overlaySizeGroups.forEach(function(g) {
      var active = g.size === activeSize;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-overlay__size' + (active ? ' is-active' : '');
      btn.dataset.size = g.size;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.innerHTML =
        '<span class="bundle-overlay__size-label">' + g.label + '</span>' +
        '<span class="bundle-overlay__size-count">' + getSizeQty(g.size) + '/' + g.max + '</span>';
      bar.appendChild(btn);
    });
  }

  // Refresh counts + active/complete state without rebuilding (listener is delegated on the bar).
  function updateSizeBar() {
    if (!overlayEl) return;
    var bar = overlayEl.querySelector('.bundle-overlay__sizes');
    if (!bar) return;
    var btns = bar.querySelectorAll('.bundle-overlay__size');
    btns.forEach(function(btn) {
      var size = btn.dataset.size;
      var active = size === activeSize;
      btn.classList.toggle('is-active', active);
      btn.classList.toggle('is-complete', isSizeFull(size));
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      var countEl = btn.querySelector('.bundle-overlay__size-count');
      if (countEl) countEl.textContent = getSizeQty(size) + '/' + getSizeMax(size);
    });
  }

  function wireSizeBar() {
    if (!overlayEl) return;
    var bar = overlayEl.querySelector('.bundle-overlay__sizes');
    if (!bar || bar.dataset.wired) return;
    bar.dataset.wired = 'true';
    bar.addEventListener('click', function(e) {
      var btn = e.target.closest('.bundle-overlay__size');
      if (btn) setActiveSize(btn.dataset.size);
    });
  }

  function setActiveSize(size) {
    if (!size || activeSize === size) return;
    activeSize = size;
    var list = overlayEl.querySelector('.bundle-overlay__list');
    if (list) list.scrollTop = 0;
    updateOverlayUI();
    announceToSR(str('sr_choosing').replace('{size}', getSizeLabel(size)).replace('{count}', getSizeQty(size)).replace('{max}', getSizeMax(size)));
  }

  // ============================================
  // MOBILE OVERLAY — product list (Phase M3)
  // ============================================

  var activeOverlayTab = 'all';

  function populateOverlayProducts() {
    if (!overlayEl) return;

    var list = overlayEl.querySelector('.bundle-overlay__list');
    if (!list || list.querySelector('.bundle-overlay__row')) return;

    // Build one row set PER GROUP, each from that group's representative slot, and tag
    // every row with its group so the filter can show only the active one.
    //
    // This used to build a single list from slot 0 on the assumption that every slot
    // offers the same products and only the size differs. That holds for the all-fragrance
    // bundles, but not for a mixed one (slot 0 = perfumes, slot 1 = shower gels): the
    // second step then listed perfumes and its own products could never be picked.
    var selects = getBundleSelects();
    if (selects.length === 0) return;

    var genderLookup = window.bundleGenderLookup || {};

    overlaySizeGroups.forEach(function(group) {
    var groupSelect = selects[group.slotIndex];
    if (!groupSelect) return;

    var options = Array.prototype.slice.call(groupSelect.options);
    var regularOptions = options.filter(function(opt) { return !isPlaceholder(opt); });

    // Sort alphabetically by product name
    regularOptions.sort(function(a, b) {
      var nameA = parseOption(a.text).name.toLowerCase();
      var nameB = parseOption(b.text).name.toLowerCase();
      return nameA.localeCompare(nameB);
    });

    regularOptions.forEach(function(nativeOpt) {
      var data = parseOption(nativeOpt.text);
      var genderRaw = genderLookup[data.name] || genderLookup[data.scentKey];
      var gender = Array.isArray(genderRaw) ? genderRaw.join(',') : (genderRaw || '');

      var row = document.createElement('div');
      row.className = 'bundle-overlay__row';
      row.setAttribute('role', 'option');
      row.setAttribute('aria-selected', 'false');
      row.setAttribute('tabindex', '0');
      row.dataset.name = data.name;
      row.dataset.group = group.size;
      row.dataset.gender = gender;
      row.dataset.value = nativeOpt.value;
      row.dataset.optionText = nativeOpt.text;
      row.dataset.searchText = data.name.toLowerCase() + ' ' + (data.inspiredBy || '').toLowerCase();

      // Image thumbnail
      var imgWrap = document.createElement('div');
      imgWrap.className = 'bundle-overlay__row-image';
      if (data.image) {
        imgWrap.innerHTML = '<img src="' + data.image + '" alt="' + data.name + '" loading="lazy">';
      } else {
        imgWrap.innerHTML = '<div class="bundle-overlay__row-placeholder"></div>';
      }

      // Info: name + gender badge
      var info = document.createElement('div');
      info.className = 'bundle-overlay__row-info';

      var nameEl = document.createElement('span');
      nameEl.className = 'bundle-overlay__row-name';
      nameEl.textContent = data.name;
      info.appendChild(nameEl);

      if (data.inspiredBy) {
        var vendorEl = document.createElement('span');
        vendorEl.className = 'bundle-overlay__row-vendor';
        vendorEl.textContent = str('inspired_by').replace('{vendor}', data.inspiredBy);
        info.appendChild(vendorEl);
      }

      if (gender) {
        var badgeWrap = document.createElement('div');
        badgeWrap.className = 'bundle-overlay__row-badges';
        var genders = gender.split(',');
        for (var g = 0; g < genders.length; g++) {
          var gVal = genders[g].trim();
          if (!gVal) continue;
          var badge = document.createElement('span');
          var badgeClass = 'bundle-overlay__row-badge';
          if (gVal === 'For Him') badgeClass += ' bundle-overlay__row-badge--him';
          else if (gVal === 'For Her') badgeClass += ' bundle-overlay__row-badge--her';
          else if (gVal === 'Unisex') badgeClass += ' bundle-overlay__row-badge--unisex';
          badge.className = badgeClass;
          badge.textContent = genderLabel(gVal);
          badgeWrap.appendChild(badge);
        }
        info.appendChild(badgeWrap);
      }

      // Checkbox (visual only — M4 wires interaction)
      var checkArea = document.createElement('div');
      checkArea.className = 'bundle-overlay__row-action';
      checkArea.innerHTML =
        '<div class="bundle-overlay__checkbox">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">' +
            '<path d="M2 6L5 9L10 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>';

      row.appendChild(imgWrap);
      row.appendChild(info);
      row.appendChild(checkArea);
      list.appendChild(row);
    });

    }); // end per-group loop

    // No results message
    var noResults = document.createElement('div');
    noResults.className = 'bundle-overlay__no-results';
    noResults.textContent = str('no_fragrances');
    noResults.style.display = 'none';
    list.appendChild(noResults);

    // Wire filtering
    wireOverlayTabs();
    wireOverlaySearch();
  }

  function wireOverlayTabs() {
    if (!overlayEl) return;

    var tabs = overlayEl.querySelectorAll('.bundle-overlay__tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        activeOverlayTab = tab.dataset.filter;
        filterOverlayProducts();

        // Scroll list to top on tab change
        var list = overlayEl.querySelector('.bundle-overlay__list');
        if (list) list.scrollTop = 0;
      });
    });
  }

  function wireOverlaySearch() {
    if (!overlayEl) return;

    var searchInput = overlayEl.querySelector('.bundle-overlay__search-input');
    if (!searchInput) return;

    searchInput.addEventListener('input', function() {
      filterOverlayProducts();
    });
  }

  function filterOverlayProducts() {
    if (!overlayEl) return;

    var list = overlayEl.querySelector('.bundle-overlay__list');
    if (!list) return;

    var searchInput = overlayEl.querySelector('.bundle-overlay__search-input');
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';

    var rows = list.querySelectorAll('.bundle-overlay__row');
    var visibleCount = 0;

    rows.forEach(function(row) {
      var gender = row.dataset.gender || '';
      var searchText = row.dataset.searchText || '';

      // Group filter — only the step currently being chosen is on screen
      var groupMatch = row.dataset.group === activeSize;

      // Tab filter
      var tabMatch = activeOverlayTab === 'all' || gender.indexOf(activeOverlayTab) !== -1;

      // Search filter
      var searchMatch = !query || searchText.indexOf(query) !== -1;

      if (groupMatch && tabMatch && searchMatch) {
        row.style.display = '';
        visibleCount++;
      } else {
        row.style.display = 'none';
      }
    });

    var noResults = list.querySelector('.bundle-overlay__no-results');
    if (noResults) {
      noResults.style.display = visibleCount === 0 ? '' : 'none';
    }
  }

  // ============================================
  // MOBILE OVERLAY — selection (Phase M4)
  // ============================================

  function getOverlayTotalQty() {
    var total = 0;
    overlaySizeGroups.forEach(function(g) { total += getSizeQty(g.size); });
    return total;
  }

  // Auto-advance to the next unfilled size group once the active one fills up.
  function maybeAdvanceSize() {
    if (!isMultiSize() || !isSizeFull(activeSize)) return;
    var idx = 0;
    for (var i = 0; i < overlaySizeGroups.length; i++) {
      if (overlaySizeGroups[i].size === activeSize) { idx = i; break; }
    }
    for (var j = 1; j <= overlaySizeGroups.length; j++) {
      var g = overlaySizeGroups[(idx + j) % overlaySizeGroups.length];
      if (!isSizeFull(g.size)) { activeSize = g.size; return; }
    }
  }

  function wireOverlayRows() {
    if (!overlayEl) return;
    // Don't double-wire
    if (overlayEl.querySelector('.bundle-overlay__qty')) return;

    var rows = overlayEl.querySelectorAll('.bundle-overlay__row');
    rows.forEach(function(row) {
      // Build qty selector (hidden initially)
      var action = row.querySelector('.bundle-overlay__row-action');
      var qtyEl = document.createElement('div');
      qtyEl.className = 'bundle-overlay__qty';
      qtyEl.style.display = 'none';
      qtyEl.innerHTML =
        '<button type="button" class="bundle-overlay__qty-btn bundle-overlay__qty-minus">\u2212</button>' +
        '<span class="bundle-overlay__qty-value">1</span>' +
        '<button type="button" class="bundle-overlay__qty-btn bundle-overlay__qty-plus">+</button>';
      action.appendChild(qtyEl);

      // Row tap → toggle selection within the ACTIVE size group
      row.addEventListener('click', function(e) {
        if (e.target.closest('.bundle-overlay__qty-btn')) return;
        var name = row.dataset.name;
        // A row belongs to exactly one group — never write it into a different step's bucket.
        var grp = row.dataset.group;
        var bucket = overlaySelections[grp] || (overlaySelections[grp] = {});
        if (bucket[name]) {
          delete bucket[name];
        } else {
          if (isSizeFull(grp)) return;
          bucket[name] = {
            qty: 1,
            value: row.dataset.value,
            optionText: row.dataset.optionText
          };
          maybeAdvanceSize();
        }
        updateOverlayUI();
      });

      // Minus button
      qtyEl.querySelector('.bundle-overlay__qty-minus').addEventListener('click', function(e) {
        e.stopPropagation();
        var name = row.dataset.name;
        var bucket = overlaySelections[row.dataset.group] || {};
        if (!bucket[name]) return;
        bucket[name].qty--;
        if (bucket[name].qty <= 0) delete bucket[name];
        updateOverlayUI();
      });

      // Plus button
      qtyEl.querySelector('.bundle-overlay__qty-plus').addEventListener('click', function(e) {
        e.stopPropagation();
        var name = row.dataset.name;
        var bucket = overlaySelections[row.dataset.group] || {};
        if (!bucket[name]) return;
        if (isSizeFull(row.dataset.group)) return;
        bucket[name].qty++;
        maybeAdvanceSize();
        updateOverlayUI();
      });
    });
  }

  function updateOverlayUI() {
    if (!overlayEl) return;

    var activeBucket = overlaySelections[activeSize] || {};
    var activeFull = isSizeFull(activeSize);
    var totalQty = getOverlayTotalQty();
    var allFull = totalQty >= overlayBundleSize;

    // Show only the active group's rows (each group has its own product list)
    filterOverlayProducts();

    // Rows reflect the ACTIVE size group's selections
    var rows = overlayEl.querySelectorAll('.bundle-overlay__row');
    rows.forEach(function(row) {
      if (row.dataset.group !== activeSize) return;
      var name = row.dataset.name;
      var sel = activeBucket[name];
      var checkbox = row.querySelector('.bundle-overlay__checkbox');
      var qtyEl = row.querySelector('.bundle-overlay__qty');

      if (sel) {
        row.classList.add('is-selected');
        row.classList.remove('is-disabled');
        row.setAttribute('aria-selected', 'true');
        row.setAttribute('aria-disabled', 'false');
        if (checkbox) checkbox.style.display = 'none';
        if (qtyEl) {
          qtyEl.style.display = '';
          qtyEl.querySelector('.bundle-overlay__qty-value').textContent = sel.qty;
          qtyEl.querySelector('.bundle-overlay__qty-plus').disabled = activeFull;
        }
      } else {
        row.classList.remove('is-selected');
        row.setAttribute('aria-selected', 'false');
        if (checkbox) checkbox.style.display = '';
        if (qtyEl) qtyEl.style.display = 'none';
        if (activeFull) {
          row.classList.add('is-disabled');
          row.setAttribute('aria-disabled', 'true');
        } else {
          row.classList.remove('is-disabled');
          row.setAttribute('aria-disabled', 'false');
        }
      }
    });

    // Size steps
    updateSizeBar();

    // Footer
    var footerStatus = overlayEl.querySelector('.bundle-overlay__footer-status');
    var footerText = overlayEl.querySelector('.bundle-overlay__footer-text');
    var footerRow = overlayEl.querySelector('.bundle-overlay__footer-row');
    var footerClear = footerStatus ? footerStatus.querySelector('.bundle-overlay__footer-clear') : null;

    if (allFull) {
      if (footerStatus) footerStatus.style.display = 'none';
      if (footerRow) footerRow.style.display = 'flex';
    } else {
      if (footerStatus) footerStatus.style.display = '';
      if (footerText) footerText.textContent = buildFooterStatusText();
      if (footerClear) footerClear.style.display = totalQty > 0 ? 'inline-block' : 'none';
      if (footerRow) footerRow.style.display = 'none';
    }

    // Mobile trigger
    updateMobileTrigger(totalQty, overlayBundleSize);

    // Screen reader
    if (allFull) announceToSR(str('sr_all_selected').replace('{total}', overlayBundleSize));
    else announceToSR(buildFooterStatusText());
  }

  // Footer status: per-size progress for multi-size bundles, single count otherwise.
  function buildFooterStatusText() {
    if (isMultiSize()) {
      return overlaySizeGroups.map(function(g) {
        return g.label + ' ' + getSizeQty(g.size) + '/' + g.max;
      }).join('  ·  ');
    }
    return str('items_selected_caps').replace('{count}', getOverlayTotalQty()).replace('{total}', overlayBundleSize);
  }

  function findOptionByName(selectEl, productName) {
    var opts = selectEl.options;
    for (var i = 0; i < opts.length; i++) {
      if (isPlaceholder(opts[i])) continue;
      var parsed = parseOption(opts[i].text);
      if (parsed.name === productName) return opts[i].value;
    }
    return null;
  }

  function syncSelectionsToSelects() {
    var selects = getBundleSelects();
    var dropdowns = document.querySelectorAll('.bundle-dropdown');

    // Expand each size group's picks into a FIFO queue of product names.
    var queues = {}; // size -> [name, name, ...]
    overlaySizeGroups.forEach(function(g) { queues[g.size] = []; });
    Object.keys(overlaySelections).forEach(function(size) {
      if (!queues[size]) queues[size] = [];
      var bucket = overlaySelections[size];
      Object.keys(bucket).forEach(function(name) {
        for (var q = 0; q < bucket[name].qty; q++) queues[size].push(name);
      });
    });

    // Fill each slot from the queue matching THAT slot's size, in slot order.
    // findOptionByName resolves the right-sized option within each specific select.
    for (var i = 0; i < selects.length; i++) {
      var queue = queues[overlaySlotSizes[i]] || [];
      var name = queue.length ? queue.shift() : null;

      if (name) {
        var matched = findOptionByName(selects[i], name);
        selects[i].value = (matched !== null) ? matched : '';
        if (matched !== null) chosenValues[slotKey(selects[i], i)] = matched;
        else delete chosenValues[slotKey(selects[i], i)];
        selects[i].dispatchEvent(new Event('change', { bubbles: true }));
        if (i < dropdowns.length) {
          dropdowns[i].classList.add('has-selection');
          dropdowns[i].dataset.selectedTitle = name;
        }
      } else {
        delete chosenValues[slotKey(selects[i], i)];
        if (selects[i].options.length > 0) {
          selects[i].selectedIndex = 0;
          selects[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (i < dropdowns.length) {
          dropdowns[i].classList.remove('has-selection');
          delete dropdowns[i].dataset.selectedTitle;
        }
      }
    }
  }

  function clearAllSelections() {
    var fresh = {};
    overlaySizeGroups.forEach(function(g) { fresh[g.size] = {}; });
    overlaySelections = fresh;
    if (overlaySizeGroups.length) activeSize = overlaySizeGroups[0].size;
    updateOverlayUI();
  }

  function wireOverlayClearAll() {
    if (!overlayEl) return;
    var clearBtns = overlayEl.querySelectorAll('.bundle-overlay__footer-clear');
    clearBtns.forEach(function(btn) {
      if (btn.dataset.wired) return;
      btn.dataset.wired = 'true';
      btn.addEventListener('click', function() {
        clearAllSelections();
      });
    });
  }

  function wireOverlayAddToCart() {
    if (!overlayEl) return;
    var footerBtn = overlayEl.querySelector('.bundle-overlay__footer-btn');
    if (!footerBtn || footerBtn.dataset.wired) return;
    footerBtn.dataset.wired = 'true';

    footerBtn.addEventListener('click', function() {
      if (getOverlayTotalQty() < overlayBundleSize) return;
      // closeOverlay() calls syncSelectionsToSelects() + updateButtonState() internally
      closeOverlay();

      if (!addToCartButton || !addToCartButton.isConnected) addToCartButton = getAddToCartButton();
      if (addToCartButton) {
        addToCartButton.click();
      } else {
        var form = getProductForm();
        if (form) form.submit();
      }
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function processBundleContainer() {
    var container = getBundleContainer();
    if (!container) return false;

    var selects = getBundleSelects();
    if (selects.length === 0) return false;

    // Don't double-process
    if (container.dataset.bundleUiProcessed === 'true') return true;
    container.dataset.bundleUiProcessed = 'true';

    bundleReady = true;

    // Drop anything out of stock before the pickers are built from these selects.
    markOutOfStockOptions(selects);

    selects.forEach(function(select, i) {
      buildDropdown(select, i);
    });

    // Mobile overlay (Phase M2 + M3 + M4 + size steps)
    buildSlotModel();
    buildMobileTrigger(selects.length);
    buildOverlayShell(selects.length);
    buildSizeBar();
    wireSizeBar();
    populateOverlayProducts();
    wireOverlayRows();
    wireOverlayClearAll();
    wireOverlayAddToCart();

    updateButtonState();
    return true;
  }

  function init() {
    processBundleContainer();

    // Form submission handler for duplicate detection
    var form = getProductForm();
    if (form) {
      form.addEventListener('submit', handleFormSubmit, true);
    }

    // Watch for dynamically injected bundle content (Simple Bundles app)
    var observer = new MutationObserver(function(mutations) {
      var shouldProcess = false;
      var shouldUpdateButtons = false;

      mutations.forEach(function(mutation) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) return;

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          if (node.id === BUNDLE_CONTAINER_ID ||
              (node.querySelector && node.querySelector('#' + BUNDLE_CONTAINER_ID))) {
            shouldProcess = true;
          }

          if (node.tagName === 'SELECT') {
            var cont = getBundleContainer();
            if (cont && cont.contains(node)) {
              shouldProcess = true;
            }
          }

          if ((node.classList && node.classList.contains('lb-spc-details-btn')) ||
              (node.querySelector && node.querySelector('.lb-spc-details-btn'))) {
            shouldUpdateButtons = true;
          }
        });
      });

      if (shouldProcess) {
        var cont = getBundleContainer();
        if (cont) cont.dataset.bundleUiProcessed = '';
        processBundleContainer();
      }

      if (shouldUpdateButtons) {
        updateButtonState();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Phase M6: handle orientation change / resize
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (overlayEl && overlayEl.classList.contains('is-open')) {
          // Force layout recalc — 95vh handles height, but re-filter
          // in case viewport change affects visible rows
          filterOverlayProducts();
        }
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
